import config from 'config';
import classname from 'classnames';
import React, { Component, createRef, useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import SessionInfo from './SessionInfo';
import SessionSpeakersSessionsList from './sessionSections/speakers/SessionSpeakersSessionsList';
import SessionLocation from './SessionLocation';
import SessionActions from './SessionActions';
import { Link } from 'react-router';
import cls from 'classnames';
import { findDOMNode } from 'react-dom';
import { sendAnalytics } from 'utils/analyticsUtils';
import {
    VIEW_MODE_SBS,
    VIEW_MODE_LIST,
    loginClickOrigin,
} from 'constants/Enums';
import LiveBroadcastLabel from './LiveBroadcastLabel';
import JoinLiveSessionButton from './JoinLiveSessionButton';
import { getInternalWebsiteBaseUrl } from 'web-common/scripts/utils/whitelabelUtils';
import FeatureToggleUtils from 'FeatureToggleUtils';

import {
    isSessionEnded,
    isSessionStartsInMorethan,
    loadSessionPage,
    isSessionLive,
    PRE_SESSION_LIVE_TIME,
    isSessionEndedMoreThan,
    SESSION_GRACE_TIME,
    loadVirtualSessionPage
} from './sessionBroadcastUtils';
import WatchRecordingButton from './VirtualSessions/WatchRecordingButton';
import WatchExternalOnDemandSessionButton from './WatchExternalOnDemandSessionButton';

const MOBILE_DEVICE_WIDTH = 750;
const SMALL_DESCRIPTION_HEIGHT_MAX = 50;

const SpeakersComponent = ({ session, speakers, isClientSideRendered, SBSViewMode }) => {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        setIsLoading(false);
    }, [speakers]);
    const { speakers: selectedSpeakers } = session;
    const cls = classname('speakers-container', { 'has-speakers': selectedSpeakers});
    return <Col key='speakers' xs={12} className={cls}>
        {
            isLoading ?
                <></> :
                <SessionSpeakersSessionsList
                    session={session}
                    SBSViewMode={SBSViewMode}
                    selectedSpeakers={selectedSpeakers}
                    speakers={speakers}
                    classCarousel="margin-horizontal-none"
                    isClientSideRendered={isClientSideRendered}
                />
        }
    </Col>;
};

class SessionElem extends Component {
    state = {
        previewOpen: false,
        faddedAway: true,
        isBroadcastLoading: false,
        sessionAccessError: null
    };

    smallDescription = false;
    sessionDescriptionRef = createRef();
    sessionHeight = 0;
    sessionDomNode;

    static propTypes = {
        isClientSideRendered: PropTypes.bool,
        event: PropTypes.object.isRequired,
        me: PropTypes.object.isRequired,
        settings: PropTypes.object.isRequired,
        session: PropTypes.object.isRequired,
        speakers: PropTypes.object.isRequired,
        toggleMarker: PropTypes.func.isRequired,
        isSessionRegistrationEnabled: PropTypes.bool,
        eventUrls: PropTypes.object.isRequired,
        sessionClickHandler: PropTypes.func,
        showEmailLogin: PropTypes.func,
        shouldShowSessionPreviewWindow: PropTypes.bool.isRequired,
        shouldShowSessionDescriptionAgenda: PropTypes.bool,
        toggleSessionRegistrationStatusPerSession: PropTypes.func,
        openCloseTicketSelectionPopUp: PropTypes.func,
        ticketsSelectionData: PropTypes.object.isRequired,
        setSessionFullRegistration: PropTypes.func,
        isFeatureSessionVirtualElementEnabled: PropTypes.bool,
        setVirtualSessionDetails: PropTypes.func,
        setScrollToSessionBroadcastAction: PropTypes.func,
        setRecordUrl: PropTypes.func,
        showRegisterAndLoginModal: PropTypes.func
    };

    static defaultProps = {
        isClientSideRendered: false,
        isSessionRegistrationEnabled: null,
        day: 'unscheduled'
    };

    renderOrder = {
        [VIEW_MODE_LIST]: ['renderSessionInfo', 'renderBroadcast', 'renderSessionDescription', 'renderSpeakers', 'renderSponsors'],
        [VIEW_MODE_SBS]: ['renderSessionInfo', 'renderBroadcast', 'renderSessionDescription', 'renderSpeakers', 'renderSponsors'],
    };

    componentDidMount() {
        if (this.sessionDescriptionRef) {
            if (this.sessionDescriptionRef.current) {
                this.sessionDomNode = findDOMNode(this.sessionDescriptionRef.current);
            }
        }
        this.getSessionHeight();
    }

    componentDidUpdate() {
        this.getSessionHeight();
    }

    getSessionHeight = () => {
        this.sessionHeight = this.sessionDomNode && this.sessionDomNode.clientHeight || 0;
        this.smallDescription = this.sessionHeight <= SMALL_DESCRIPTION_HEIGHT_MAX;
    }

    sessionDescriptionHandler = () => {
        if (!this.smallDescription) {
            this.setState({previewOpen: !this.state.previewOpen});
            if (this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(() => this.setState({ faddedAway: !this.state.faddedAway}), 200);
        }
    }

    shouldShowSessionDescription = () => {
        const { session, shouldShowSessionDescriptionAgenda } = this.props;
        return shouldShowSessionDescriptionAgenda
                && window.innerWidth > MOBILE_DEVICE_WIDTH
                && session.description
                && session.descriptionHtml;
    };

    getStyleObject = () => {
        if (this.state.previewOpen) {
            return {maxHeight: this.sessionHeight || 0};
        } else {
            return {};
        }
    };

    renderSBSdescription = () => {
        const { session, event } = this.props;
        const url = getInternalWebsiteBaseUrl(event, `agenda/session/${session.id}`);
        return <Row>
            <Col md={12}
                lg={12}
                className='sbs-preview-session-description custom-font'
            >
                <div dangerouslySetInnerHTML={{__html: session.descriptionHtml}}/>

            </Col>
            <Col md={12} className='sbs-read-more-link'>
                <Link to={url}><span className='read-more'>Read More</span></Link>
            </Col>
        </Row>;
    };

    renderRegularDescription = () => {
        const { session } = this.props;
        const { previewOpen, faddedAway } = this.state;
        const className = cls('preview-session-description', {
            'opened': previewOpen,
            'small-description': this.smallDescription,
            'faddedAway': !previewOpen && faddedAway
        });
        return <Row>
            <Col md={12}
                lg={12}
                className={className}
                style={this.getStyleObject()}
                onClick={this.sessionDescriptionHandler}>
                <div ref={this.sessionDescriptionRef}
                    className='session-description-inner'
                    dangerouslySetInnerHTML={{__html: session.descriptionHtml}}/>
            </Col>
        </Row>;
    };

    renderSessionDescription = () => {
        const { SBSViewMode } = this.props;
        return <Col key='description' className="description-container" xs={12}>
            {
                this.shouldShowSessionDescription()
                    ? SBSViewMode
                        ? this.renderSBSdescription()
                        : this.renderRegularDescription()
                    : null
            }
        </Col>;
    };

    renderBroadcast = () => {
        const {
            session,
            isFeatureSessionVirtualElementEnabled,
            eventUrls,
            showEmailLogin,
            me,
            event,
            setVirtualSessionDetails,
            color,
            siteConf,
            setScrollToSessionBroadcastAction,
            setRecordUrl,
            showRegisterAndLoginModal,
            setLoginV2OffsetTop,
            ticketsSelectionData,
            isRingAvailable,
        } = this.props;

        const isAuthenticated = !!(me && me.id);
        const timeZone = event && event['time-zone-id'];
        const enableVirtualSession = session.enableVirtualSession;

        const enableRecordingSession = session.enableRecordingSession;
        const isOnDemandFeatureEnabled = FeatureToggleUtils.isFeatureEnabled('sessionRecording');
        let { recordingIsReady = false, broadcastRecording = false } = session.recordingSession ?? {};

        if (
            isRingAvailable ||
            !isFeatureSessionVirtualElementEnabled ||
            (!enableVirtualSession && (!enableRecordingSession || !isOnDemandFeatureEnabled))
        ){
            return null;
        }

        const eventStartDate = event && event['start-date'];
        const eventStarted = Date.now() > eventStartDate;
        const sessionIsUnscheduled = !session.startDate;
        const isSessionInMoreThanPreliveTime = isSessionStartsInMorethan(session, PRE_SESSION_LIVE_TIME, timeZone);
        const isSessionOver = isSessionEnded(session, timeZone);
        const isSessionLiveNow = isSessionLive(session, timeZone);
        const isSessionPassedGraceTime = sessionIsUnscheduled || isSessionEndedMoreThan(session, SESSION_GRACE_TIME, timeZone);
        const customColor = color || siteConf?.color1;
        const recordingReady = enableRecordingSession && broadcastRecording && recordingIsReady;
        const recordingOrOnDemandAvailable = (isSessionLiveNow || isSessionOver || (eventStarted && sessionIsUnscheduled)) && recordingReady;
        const showWatchRecordingButton = recordingOrOnDemandAvailable && enableVirtualSession && isSessionOver;
        const showOnDemandButton = recordingOrOnDemandAvailable && !enableVirtualSession && (isSessionOver || sessionIsUnscheduled);
        const isExternalOnDemand = session?.recordingSession?.recordingPrimaryAssetType === 'EXTERNAL';
        const onDemandButtonText = showWatchRecordingButton ? 'Watch Recording' : (sessionIsUnscheduled ? 'Watch On Demand' : 'Watch Session');
        const sessionRecordingNotReady = !broadcastRecording || !recordingIsReady;

        return (
            <Col key='broadcasting' className="broadcasting-container sbs-view" xs={12}>
                {
                    isSessionLiveNow &&
                    (
                        <JoinLiveSessionButton
                            event={event}
                            me={me}
                            session={session}
                            eventUrls={eventUrls}
                            showEmailLogin={showEmailLogin}
                            setVirtualSessionDetails={setVirtualSessionDetails}
                            setScrollToSessionBroadcastAction={setScrollToSessionBroadcastAction}
                            btnText="Join Session"
                            setRecordUrl={setRecordUrl}
                            showRegisterAndLoginModal={showRegisterAndLoginModal}
                            siteConf={siteConf}
                            setLoginV2OffsetTop={setLoginV2OffsetTop}
                            analyticData={{
                                clickOrigin: loginClickOrigin.agenda.join('Join Broadcast'),
                                sessionId: session?.id
                            }}
                        />
                    )
                }
                {
                    enableVirtualSession &&
                    isSessionInMoreThanPreliveTime &&
                    <LiveBroadcastLabel
                        color={customColor}
                        label="Broadcast"
                        additionalText={`Starts ${PRE_SESSION_LIVE_TIME} min before the session time`}
                    />
                }
                {
                    isSessionOver &&
                    !enableRecordingSession &&
                    <LiveBroadcastLabel
                        label="Broadcast has ended"
                        color={customColor}
                    />
                }
                {
                    (
                        enableRecordingSession && sessionRecordingNotReady && ((isSessionOver && !isSessionPassedGraceTime) ||
                            (eventStarted && sessionIsUnscheduled))
                    ) &&
                    <LiveBroadcastLabel
                        label="Broadcast has ended"
                        additionalText="Recording will be ready soon"
                        color={customColor}
                    />
                }
                {
                    (showWatchRecordingButton || showOnDemandButton) && !isExternalOnDemand &&
                    <WatchRecordingButton
                        onClick={() => loadSessionPage({ event, sessionId: session.id })}
                        isAuthenticated={isAuthenticated}
                        eventUrls={eventUrls}
                        showEmailLogin={showEmailLogin}
                        showRegisterAndLoginModal={showRegisterAndLoginModal}
                        isWidget={siteConf?.isWidget}
                        eventName={event?.name}
                        setLoginV2OffsetTop={setLoginV2OffsetTop}
                        text={onDemandButtonText}
                        analyticData={{
                            clickOrigin: loginClickOrigin.agenda.join(onDemandButtonText),
                            sessionId: session?.id
                        }}
                    />
                }
                { (showWatchRecordingButton || showOnDemandButton) && isExternalOnDemand &&
                <WatchExternalOnDemandSessionButton
                    event={event}
                    eventUrls={eventUrls}
                    me={me}
                    session={session}
                    showRegisterAndLoginModal={showEmailLogin}
                    showEmailLogin={showEmailLogin}
                    ticketsSelectionData={ticketsSelectionData}
                    btnText={onDemandButtonText}
                    btnClass={'external-solution-btn'}
                    siteConf={siteConf}
                    analyticData={{
                        clickOrigin: loginClickOrigin.agenda.join(onDemandButtonText),
                        sessionId: session?.id
                    }}
                />


                }
            </Col>
        );
    };


    renderSessionInfo = () => {
        const {
            session,
            settings,
            isFeatureSessionVirtualElementEnabled,
            me,
            eventUrls,
            sessionClickHandler,
            showEmailLogin,
            shouldShowSessionPreviewWindow,
            event,
            SBSViewMode,
            color,
            clientNavigationAction
        } = this.props;

        const enableVirtualSession = isFeatureSessionVirtualElementEnabled && session.enableVirtualSession;
        const url = getInternalWebsiteBaseUrl(event, `agenda/session/${session.id}`);
        const viewMode = SBSViewMode ? VIEW_MODE_SBS: VIEW_MODE_LIST;

        const onSessionTitleClick = async(e) => {
            e.preventDefault();
            await loadVirtualSessionPage(session.id, event);
        };

        return <Col key='session-info' className="session-info" lg={session.sponsors.length && !SBSViewMode ? 9 : 12} >
            <Row>
                <Col md={12} className="session-info-text" >
                    <SessionInfo
                        session={session}
                        settings={settings}
                        me={me}
                        eventUrls={eventUrls}
                        showEmailLogin={showEmailLogin}
                        color={color}
                        event={event}
                        numberOfLines={viewMode === VIEW_MODE_SBS ? 3 : 1}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={12} lg={12} className="session-name custom-font">
                    {
                        shouldShowSessionPreviewWindow ? (
                            <a className="session-title" onClick={e => sessionClickHandler(e, { sessionId: session.id })} title={session.title}>
                                {session.title}
                            </a>
                        ) : enableVirtualSession ? (
                            <a className="session-title" onClick={onSessionTitleClick} title={session.title}>
                                {session.title}
                            </a>
                        ) : (
                            <Link className="session-title" title={session.title} to={url} onClick={clientNavigationAction}>
                                {session.title}
                            </Link>
                        )
                    }
                </Col>
            </Row>
            <Row className='padding-horizontal-small location-wrapper'>
                {session.locationId && session.location && <SessionLocation session={session}/>}
            </Row>
        </Col>;
    };

    sponsorClick = (sponsor) => {
        if (sponsor?.['website-url']) {
            sendAnalytics('sponsorClick', {
                appearance: 'sessionsList',
                sponsorId: sponsor?.id
            });

            window.open(sponsor['website-url']);
        }
    };

    renderSponsors = () => {
        const { session: { sponsorsTitle, sponsors }, SBSViewMode } = this.props;
        let countLogos = 0;
        sponsors.forEach(sponsor => sponsor['logo-url'] ? countLogos++ : null);
        const titleClassName = classname( 'sponsored-by', { 'text-left': SBSViewMode});
        const shouldRenderSponsors = sponsors.length > 0 || SBSViewMode;
        return (
            shouldRenderSponsors && <Col lg={12} key='sponsors' className='sponsors-container'>
                {
                    sponsors.length || SBSViewMode
                        ? <React.Fragment>
                            {
                                countLogos
                                    ? <div className={titleClassName}>
                                        { sponsorsTitle || 'Sponsored By:' }
                                    </div>
                                    : null
                            }
                            <div className={classname('sponsors-logo-content clearfix', {'one-sponsor-content': countLogos === 1 || sponsors.length === 1 })}>
                                {this.getSponsorsToShow(sponsors, countLogos)}
                            </div>
                        </React.Fragment>
                        : null
                }
            </Col>
        );
    };

    getSponsorsToShow = (sponsors, countLogos) => {
        let sponsorsArr = [];
        const oneSponsor = sponsors.length === 1;
        sponsors.forEach((sponsor, i) => {
            if (sponsor['logo-url']) {
                const logoUrl = sponsor['logo-url'];
                // Append a ?cache-fix query param to bust stale browser cache
                // entries that were stored with no-CORS mode before SUPP-18662.
                const sponsorLogoSrc = logoUrl ? `${logoUrl}${logoUrl.includes('?') ? '&' : '?'}cache-fix` : '';
                sponsorsArr.push(
                    <Col
                        key={sponsor.id}
                        className={classname(`sponsor-column sponsor-${i + 1}`, {
                            'one-sponsor': oneSponsor || countLogos === 1,
                        })}>
                        <img alt="sponsor"
                            className={classname('sponsor-image', {'clickable': sponsor['website-url']})}
                            src={sponsorLogoSrc}
                            crossOrigin=''
                            onClick={() => this.sponsorClick(sponsor)}/>
                    </Col>
                );
            }
        });
        return sponsorsArr;
    };

    renderSpeakers = () => {
        const { session,
            speakers,
            isClientSideRendered,
            SBSViewMode
        } = this.props;
        return <SpeakersComponent
            key={session?.id}
            session={session}
            speakers={speakers}
            isClientSideRendered={isClientSideRendered}
            SBSViewMode={SBSViewMode}/>;
    };

    renderSessionContent = () => {
        const { SBSViewMode, elementsToRender } = this.props;
        const viewMode = SBSViewMode ? VIEW_MODE_SBS: VIEW_MODE_LIST;
        return <React.Fragment>
            { this.renderOrder[viewMode].map(renderFuncName => elementsToRender
                ? elementsToRender[renderFuncName] && this[renderFuncName]()
                : this[renderFuncName]())
            }
        </React.Fragment>;
    };

    render() {
        const {
            session: { title, backgroundColor},
            session,
            me,
            eventUrls,
            toggleMarker,
            showEmailLogin,
            toggleSessionRegistrationStatusPerSession,
            openCloseTicketSelectionPopUp,
            ticketsSelectionData,
            event: { websiteType },
            event,
            setSessionFullRegistration,
            index,
            shouldStickAgendaSearch,
            settings: { showAddToCal },
            setLoginV2OffsetTop,
            siteConf,
            isRingAvailable,
        } = this.props;
        let qaClass = '';

        if (config.env !== 'prod') {
            qaClass = `qa-session-${title}`;
        }
        const containerCls = classname('session-container make-relative full-width', qaClass);
        const agendaVenueAlignmentEnabled = FeatureToggleUtils.isFeatureEnabled('seshreg-agenda-venue-behavior-alignment');
        const shouldRenderActions = agendaVenueAlignmentEnabled || !isRingAvailable;
        return (
            <div className={containerCls} style={{background: `${backgroundColor}`}}>
                {
                    shouldRenderActions && <SessionActions
                        me={me}
                        eventUrls={eventUrls}
                        session={session}
                        toggleMarker={toggleMarker}
                        showEmailLogin={showEmailLogin}
                        sessionViewType={'sessionsList'}
                        buttonsDirectionHorizontal={false}
                        toggleSessionRegistrationStatusPerSession={toggleSessionRegistrationStatusPerSession}
                        openCloseTicketSelectionPopUp={openCloseTicketSelectionPopUp}
                        ticketsSelectionData={ticketsSelectionData}
                        websiteType={websiteType}
                        event={event}
                        setSessionFullRegistration={setSessionFullRegistration}
                        index={index}
                        shouldStickAgendaSearch={shouldStickAgendaSearch}
                        showAddToCal={showAddToCal}
                        setLoginV2OffsetTop={setLoginV2OffsetTop}
                        siteConf={siteConf}
                    />
                }
                { this.renderSessionContent() }
            </div>
        );
    }
}

export default SessionElem;
